import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const getShopCampaignAverage = async (domain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: "campaigns/averages",
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}